mutation EntityTagCardHolderCreate($input: EntityTagCardHolderCreateInput!) {
  entityTagCardHolderCreate(input: $input) {
    entityTags {
      id
      tagId
      entityId
      appId
    }
  }
}